module.exports = __webpack_public_path__ + "img/queue-3.dfe1c6e6.svg";